(function() {
  var btn = document.getElementById('lights-toggle-btn');
  var label = document.querySelector('.lights-toggle-label');

  function updateState(isOn) {
    document.body.classList.toggle('lights-on', isOn);
    if (label) {
      label.textContent = isOn ? 'Éteindre' : 'Allumer';
    }
  }

  if (btn) {
    btn.addEventListener('click', function() {
      updateState(!document.body.classList.contains('lights-on'));
    });
  }

  // Menu burger
  var menuSummary = document.querySelector('#Details-menu-drawer-container > summary');
  if (menuSummary) {
    menuSummary.addEventListener('click', function() {
      var menuDetails = document.getElementById('Details-menu-drawer-container');
      document.body.classList.toggle('menu-is-open', !menuDetails.open);
    });
  }
})();